<template>
  <CModal 
    class="modal__footer-empty edit-auction-modal"
    :close-on-backdrop="false"
    :show="show"
    @update:show="closeModal"
  >
    <h5 class="text-center">Change password</h5>
    <form
      ref="changePasswordForm"
      class=""
      autocomplete="off"
      @submit.prevent="onSubmitChangePasswordForm"
    >
      <fieldset class="form-group ">
        <label for="old_password">Current password</label>
        <input
          class="form-control"
          name="old_password"
          type="password"
          autocomplete="off"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
          id="id-old_password"
          value=""
          required
          v-model="formData.password"
        >
        <p
          class="text-danger"
          v-if="isSignInPasswordError"
        >{{ changePasswordErrorDescription }}</p>
      </fieldset>
      <fieldset class="form-group ">
        <label for="password">New password</label>
        <input
          id="id-password"
          class="form-control"
          name="password"
          type="password"
          autocomplete="off"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
          value=""
          required
          v-model="formData.newPassword"
        >
        <p
          class="text-danger"
          v-if="isPasswordError"
        >{{ changePasswordErrorDescription }}</p>
      </fieldset>
      <fieldset class="form-group ">
        <label for="confirm_password">Re-enter new password</label>
        <input
          ref="confirmPasswordInput"
          class="form-control"
          name="confirm_password"
          type="password"
          autocomplete="off"
          autocapitalize="off"
          autocorrect="off"
          spellcheck="false"
          id="id-confirm_password"
          value=""
          required
          @input="validateConfirmPasswordInput"
        >
      </fieldset>
      <button
        type="submit"
        class="btn btn-primary"
        :class="{ disabled: sending }"
        :disabled="sending"
      >Change Password</button>
    </form>
  </CModal>
</template>

<script>
import * as inputErrorHandler from '@/utils/validation/inputErrorHandler'
import {
  managersManagerStore,
  createManagersManagerMixin
} from '@/mixins/managersManagerMixin'
import { ModalType } from '@/utils/dictionaries/modalType'
import { modalStore } from "@/mixins/modalsMixin"

export default {
  name: 'ChangePasswordModal',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  mixins: [
    createManagersManagerMixin()
  ],

  data: () => ({
    formData: {
      password: '',
      newPassword: '',
    },
    sending: false,
    changePasswordError: null
  }),

  watch: {
    show() {
      this.formData = {
        password: '',
        newPassword: ''
      }

      if (this.$refs.confirmPasswordInput) {
        this.$refs.confirmPasswordInput.value = ''
      }
    }
  },

  computed: {
    isPasswordError() {
      return inputErrorHandler.isPasswordError(this.changePasswordError)
    },
    isSignInPasswordError() {
      return inputErrorHandler.isSignInPasswordError(this.changePasswordError)
    },
    changePasswordErrorDescription() {
      return inputErrorHandler.getErrorDescription(this.changePasswordError)
    }
  },

  methods: {
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    },
    setChangePasswordError(v) {
      this.changePasswordError = v
    },
    validateConfirmPasswordInput() {
      if (!this.$refs.confirmPasswordInput) return

      if(this.$refs.confirmPasswordInput.value !== this.formData.newPassword) {
        this.$refs.confirmPasswordInput.setCustomValidity('Passwords Don"t Match')
      } else {
        this.$refs.confirmPasswordInput.setCustomValidity('');
      }
    },
    async onSubmitChangePasswordForm() {
      this.validateConfirmPasswordInput()
      if (!this.$refs.changePasswordForm.checkValidity()) return
      this.sending = true
      this.setChangePasswordError()

      try {
        await this[managersManagerStore.actionTypes.ACTION_CHANGE_PASSWORD]({ ...this.formData })
        this.$modals.open({
          title: 'Success!',
          body: 'Your password has been changed'
        })
        setTimeout(() => {
          this.$modals.close()
        }, 3000)
      } catch (error) {
        console.log(error.response)
        this.setChangePasswordError(error.response.data)
      } finally {
        this.sending = false
      }
    },
  },
}
</script>
